// extracted by mini-css-extract-plugin
export default {"root":"Teachers_root__knD0f","actions":"Teachers_actions__kG-ny","input":"Teachers_input__a4gOd"};